import { render, staticRenderFns } from "./CombinationsConfiguratorCanvasHero.vue?vue&type=template&id=326ca420&scoped=true"
import script from "./CombinationsConfiguratorCanvasHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsConfiguratorCanvasHero.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326ca420",
  null
  
)

export default component.exports